var App = App || {};

App.ComponentTransactions = (function ($) {
    'use strict';

    var splideInstance = null;
    var altSplideInstance = null;
    var allSlides = [];

    function isMobile() {
        return window.innerWidth < 768;
    }

    function isStandardSlider() {
        return $('#lendingSlider').length > 0;
    }

    function destroySplide(instance) {
        if (instance) {
            try {
                instance.destroy(true);
            } catch (e) { }
        }
        return null;
    }

    function syncArrowVisibility() {
        var sliderId = isStandardSlider() ? '#lendingSlider' : '#lendingSliderAlternative';
        var pageCount = $(sliderId).find('.splide__pagination .splide__pagination__page').length;
        $(sliderId).find('.splide__arrow').toggle(pageCount > 1);
    }

    function initStandardCarousel() {
        var $slider = $('#lendingSlider');
        if (!$slider.find('.splide__slide').length) return;

        if (isMobile()) {
            if (!splideInstance) {
                splideInstance = new Splide('#lendingSlider', {
                    type: 'loop',
                    perPage: 1,
                    gap: '20px',
                    arrows: true,
                    pagination: true,
                    rewind: false
                });
                splideInstance.on('mounted', syncArrowVisibility);
                splideInstance.mount();
            }
        } else {
            splideInstance = destroySplide(splideInstance);
        }
    }

    function initAltCarousel() {
        var $slider = $('#lendingSliderAlternative');
        var slideCount = $slider.find('.splide__slide').length;

        if (!slideCount) return;

        var needsCarousel = slideCount > 3 || (isMobile() && slideCount > 1);

        if (needsCarousel) {
            $slider.removeClass('desktop-splide-slider');

            if (!altSplideInstance) {
                var perPage = slideCount > 3 ? 3 : 1;

                altSplideInstance = new Splide('#lendingSliderAlternative', {
                    type: 'loop',
                    gap: '20px',
                    arrows: true,
                    pagination: true,
                    perPage: perPage,
                    rewind: false,
                    breakpoints: {
                        1024: { perPage: Math.min(perPage, 2) },
                        768: { perPage: 1 }
                    }
                });

                $('.commercial-slider-controls .splide__arrows').empty();
                $('.commercial-slider-controls .splide__pagination').empty();

                altSplideInstance.on('mounted', syncArrowVisibility);
                altSplideInstance.mount();
            }
        } else {
            $slider.addClass('desktop-splide-slider');
            altSplideInstance = destroySplide(altSplideInstance);
        }
    }

    function Carousel() {
        if (isStandardSlider()) {
            initStandardCarousel();
        } else {
            initAltCarousel();
        }
    }

    function applyFilter(selectedValue) {
        var sliderId = isStandardSlider() ? '#lendingSlider' : '#lendingSliderAlternative';

        if (isStandardSlider()) {
            splideInstance = destroySplide(splideInstance);
        } else {
            altSplideInstance = destroySplide(altSplideInstance);
        }

        var $list = $(sliderId + ' .splide__list');
        $list.empty();

        $.each(allSlides, function (_, slide) {
            var transValue = $(slide).attr('trans-data');
            if (selectedValue === 'Select' || transValue === selectedValue) {
                $list.append($(slide).clone());
            }
        });

        Carousel();
    }

    function storeSlides() {
        var sliderId = isStandardSlider()
            ? '#lendingSlider .splide__slide'
            : '#lendingSliderAlternative .splide__slide';
        allSlides = $(sliderId).toArray();
    }

    function initDefaultFilter() {
        var $dropdown = $('#TransDropdown');
        var defaultCategory = $dropdown.data('default-category');
        
        if (defaultCategory) {
            applyFilter(defaultCategory.toString());
        }
    }

    $('#TransDropdown').on('change', function () {
        applyFilter($(this).val());
    });

    var resizeTimer;
    $(window).on('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
            var currentFilter = $('#TransDropdown').val() || 'Select';
            if (isStandardSlider()) {
                splideInstance = destroySplide(splideInstance);
            } else {
                altSplideInstance = destroySplide(altSplideInstance);
            }
            applyFilter(currentFilter);
        }, 150);
    });

    return {
        Carousel: Carousel,
        storeSlides: storeSlides,
        applyFilter: applyFilter,
        initDefaultFilter: initDefaultFilter
    };

})(jQuery);

$(function () {
    App.ComponentTransactions.storeSlides();
    
    var $dropdown = $('#TransDropdown');
    if ($dropdown.length && $dropdown.data('default-category')) {
        App.ComponentTransactions.initDefaultFilter();
    } else {
        App.ComponentTransactions.Carousel();
    }
});